/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './ActionRequiredMenuTile.css';
import { Grid, Typography } from '@mui/material';

import { useTranslate } from '../../../hooks';
import { useAppSelector } from '../../../infra/hooks';

interface contentTileType {
  name: string;
  onClick?: any;
  selectedMenu?: any;
}
const ActionRequiredMenuTile: React.FC<contentTileType> = ({
  name,
  onClick,
}) => {
  const { translate, isRTL } = useTranslate();
  const app = useAppSelector((state) => state.actionRequiredSlice);

  return (
    <Grid
      container
      className={
        app?.actionRequiredValue === name
          ? 'selected-action'
          : 'action_required_tile'
      }
      onClick={onClick}
    >
      <Grid item>
        <Typography fontSize={'14px'}>{translate(name)}</Typography>
      </Grid>
      <Grid item>
        <i className={!isRTL ? 'las la-angle-right' : 'las la-angle-left'} />
      </Grid>
    </Grid>
  );
};

export default ActionRequiredMenuTile;
